import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Language as LanguageIcon } from '@/shared/ui/icons';
import { supportedLanguages } from '../../i18n';

/**
 * 語言切換元件
 * 可放置於 Header 或 Settings 頁面
 */
export function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleLanguageChange = (langCode: string) => {
        i18n.changeLanguage(langCode);
        setOpen(false);
    };

    const currentLang = supportedLanguages.find((lang) => lang.code === i18n.language);

    return (
        <div className="dropdown dropdown-end">
            <button
                type="button"
                tabIndex={0}
                className="btn btn-ghost btn-circle"
                aria-expanded={open}
                title={currentLang?.nativeName || 'Language'}
                onClick={() => setOpen((prev) => !prev)}
            >
                <LanguageIcon className="h-5 w-5" />
            </button>
            <ul
                tabIndex={0}
                className="menu dropdown-content z-[70] mt-3 w-48 rounded-2xl border border-base-300 bg-base-100 p-2 shadow-xl"
            >
                {supportedLanguages.map((lang) => (
                    <li key={lang.code}>
                        <button
                            type="button"
                            className={i18n.language === lang.code ? 'active' : ''}
                            onClick={() => handleLanguageChange(lang.code)}
                        >
                            {lang.nativeName}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
